module.exports = __webpack_public_path__ + "img/honor-1.b6f78a93.png";